<template>
    <v-row dense>
        <v-col
                cols="12"
                dense>
            <v-text-field
                    v-if="field.text.type !== 'phone'"
                    v-model="value"
                    dense
                    class="ma-0 py-0"
                    counter="1024"
                    :label="field.text.placeholder"
                    :type="field.text.type"
                    :error="!!errorState"
                    :error-messages="error"
                    clearable
                    outlined />
            <MazPhoneNumberInput
                    v-if="field.text.type === 'phone'"
                    v-model="value"
                    reg="phoneInput"
                    :default-country-code="timezone"
                    :class="['ma-0','py-0', { 'phone-number-error': errorState }]" />
            <v-col
                    v-if="field.text.type === 'phone' && errorState"
                    dense
                    cols="12"
                    class="mt-0 pt-2">
                <v-messages
                        color="error"
                        :value="[error]" />
            </v-col>
        </v-col>
    </v-row>
</template>

<script>
    import Value from "../../../../../models/value.model";
    import {MazPhoneNumberInput} from 'maz-ui'
    import Field from "@/models/field.model";
    import {REGEXP_EMAIL, REGEXP_URL} from "@/models/field.model";
    import Session from "@/models/session.model";
    
    export default {
        name: "FieldTextComponent",
        components: {MazPhoneNumberInput},
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                value: null,
                error: null,
            }
        },
        computed: {
            errorState() {
                return !!this.error;
            },
            timezone() {
                return (new Session({})).currentTimezone
            }
        },
        watch: {
            value: {
                deep: true,
                handler() {
                    this.getValue().then((value) => {
                        this.$emit('updateValue', value);
                    })
                }
            }
        },
        mounted() {
            this.value = this.field.value.value;
        },
        methods: {
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                const value = new Value({
                    value: this.value,
                    isValid: true
                });
                
                if (!this.field.is_optional && value.isEmpty) {
                    this.error = 'Mandatory field';
                } else if (!value.isEmpty) {
                    if (this.isValid() === true) {
                        value.isValid = true;
                        this.error = null;
                    } else {
                        this.error = this.isValid();
                    }
                }

                if (this.error) {
                    value.isValid = false;
                    value.error = this.error;
                }
                
                return value;
            },
            validateText() {
                return this.value.length <= 1024;
            },
            validateNumber() {
                return true;
            },
            validatePhone() {
                return true;
            },
            validateEmail(newValue) {
                return REGEXP_EMAIL.test(newValue);
            },
            validateUrl(newValue) {
                return REGEXP_URL.test(newValue);
            },
            isValid() {
                switch (this.field.text.type) {
                case 'text':
                    return this.validateText(this.value) || 'The value may not be greater than 1024 characters.';
                case 'number':
                    return this.validateNumber(this.value) || 'Invalid number value';
                case 'email':
                    return this.validateEmail(this.value) || 'Invalid email';
                case 'url':
                    return this.validateUrl(this.value) || 'Invalid url';
                case 'phone':
                    return this.validatePhone(this.value) || 'Invalid phone number';
                default:
                    return 'Invalid input';
                }
            },
        }
    }
</script>

<style>
  .phone-number-error .maz-input__input {
      border-color: red !important;
  }
</style>